import loadable from '@loadable/component';
import './Rating.css';

export default loadable(() => {
  return import('./Rating.jsx');
});
